var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"fs-14"},[_vm._v(_vm._s(_vm.canShowEmail?_vm.email:'S.O.'))]),(_vm.mailTo && _vm.canShowEmail)?_c('el-link',{staticClass:"ml-5",attrs:{"underline":false,"type":"primary","href":'mailto:' + _vm.email}},[_c('i',{staticClass:"mdi mdi-email"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }